module.exports = __webpack_public_path__ + "static/media/timer.b1b1720c.svg";